import React, { useState } from 'react';
import { Layout, Row, Col, Drawer, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import '../css/Header.css'; // 使用你指定的路徑
import logoImg from '../images/logo.png'; // 使用你指定的圖片匯入方式

const { Header: AntHeader } = Layout;

const Header = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isEnglish = location.pathname.startsWith('/en');

  const menuItems = [
    { labelCh: '關於我們', labelEn: 'About Us', path: '/about', enPath: '/en/about' },
    { labelCh: '製造優勢', labelEn: 'Advantages', path: '/advantages', enPath: '/en/advantages' },
    { labelCh: '產品資訊', labelEn: 'Product', path: '/product', enPath: '/en/product' },
    { labelCh: '最新消息', labelEn: 'News', path: '/news', enPath: '/en/news' },
    { labelCh: '聯絡我們', labelEn: 'Contact Us', path: '/contact', enPath: '/en/contact' },
  ];

  const logoPath = isEnglish ? '/en' : '/';
  const drawerTitle = isEnglish ? 'Menu' : '選單';

  const toggleLanguage = () => {
    const currentPath = location.pathname;
    if (isEnglish) {
      const nextPath = currentPath.replace(/^\/en/, '') || '/';
      navigate(nextPath);
    } else {
      const nextPath = currentPath === '/' ? '/en' : `/en${currentPath}`;
      navigate(nextPath);
    }
  };

  return (
    <AntHeader className="header-nav">
      <div className="container-wide">
        {/* <div className="wave-container">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff50" fill-opacity="1" d="M0,128L48,133.3C96,139,192,149,288,160C384,171,480,181,576,165.3C672,149,768,107,864,112C960,117,1056,171,1152,186.7C1248,203,1344,181,1392,170.7L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path></svg>
        </div> */}
        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
          
          {/* Logo 靠左 */}
          <Col>
            <Link to={logoPath} className="logo-container">
              <img src={logoImg} alt="湯武生技" loading="lazy" />
            </Link>
          </Col>

          {/* Desktop Menu 靠右 */}
          <Col className="desktop-menu">
            <ul className="nav-list">
              {menuItems.map((item) => {
                const linkPath = isEnglish ? item.enPath : item.path;
                return (
                  <li key={item.path}>
                    <NavLink to={linkPath} className="nav-link">
                      <span className="content-ch">{item.labelCh}</span>
                      <span className="content-en">{item.labelEn}</span>
                    </NavLink>
                  </li>
                );
              })}

              <div className="lang-switch-btn" onClick={toggleLanguage}>
                {isEnglish ? 'CH' : 'EN'}
              </div>
            </ul>
            
          </Col>

          {/* Mobile Toggle */}
          <Col className="mobile-toggle">
            <Button 
              type="text" 
              icon={<MenuOutlined style={{ fontSize: '24px' }} />} 
              onClick={() => setVisible(true)} 
            />
          </Col>

        </Row>
      </div>

      <Drawer
        title={drawerTitle}
        placement="right"
        onClose={() => setVisible(false)}
        open={visible}
        width={250}
      >
        <ul className="mobile-nav-list">
          {menuItems.map((item) => {
            const linkPath = isEnglish ? item.enPath : item.path;
            const label = isEnglish ? item.labelEn : item.labelCh;
            return (
              <li key={item.path} style={{ marginBottom: '20px' }}>
                <NavLink to={linkPath} className="nav-link" onClick={() => setVisible(false)}>
                  {label}
                </NavLink>
              </li>
            );
          })}

          <div className="lang-switch-btn mt-50" onClick={toggleLanguage}>
            {isEnglish ? 'CH' : 'EN'}
          </div>
        </ul>
      </Drawer>
    </AntHeader>
  );
};

export default Header;